<template>
  <div class="customer_group_list">
    <div class="header">
      <el-button size="medium" type="primary" @click="toAddPage('')" v-if="isShowByPermission('/wyms/customerGroup/addGroup')">新增客服组</el-button>
    </div>
    <div class="dealer_content">
      <el-table border :height="windowHeight - 160" :data="dataList" style="width: 100%">
        <el-table-column align="center" prop="name" label="客服组名称" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="组长" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.leader.name || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="组员" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.members ? getMemberNames(scope.row.members) : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="toAddPage(scope.row.id)" v-if="isShowByPermission('/wyms/customerGroup/updateGroup')">编辑</el-button>
            <el-button type="text" @click="deleteHandler(scope.row.id)" v-if="isShowByPermission('/wyms/customerGroup/deleteGroup')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
  import {listGroup, deleteGroup} from '@/api/dealerManage'

  export default {
    name: "customerServiceGroupList",
    data() {
      return {
        dataList: []
      }
    },
    created() {
      this.listGroup();
    },
    mixins: [windowResize],
    methods: {
        isShowByPermission,
      toAddPage(groupId) {
        if (groupId) {
          this.$router.push({path: 'groupAdd', query: {groupId: groupId}})
        } else {
          this.$router.push({path: 'groupAdd'})
        }
      },
      listGroup() {
        listGroup().then(data => {
          this.dataList = data;
        })
      },
      // 删除
      deleteHandler(id) {
        this.$confirm("确认要删除当前客服组吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteGroup({groupId: id}).then(() => {
            this.$message.success('删除成功！');
            this.listGroup();
          })
        });
      },
      getMemberNames(list) {
        let nameList = [];
        list.forEach((item) => {
          nameList.push(item.name)
        });
        return nameList.toString();
      }
    }
  }
</script>

<style lang="scss">
  .customer_group_list{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      .header_right_btn{
        float:right;
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/dealerManage/customerService/customerServiceGroupList.vue